import { useContext, useEffect } from "react";

import { MboxContext } from "@swa-ui/application";
import { window } from "@swa-ui/browser";

export const MboxScripts = () => {
  const { mboxes } = useContext(MboxContext);

  useEffect(() => {
    mboxes?.scripts?.forEach((mboxScript) => {
      const script = window.document.createElement("script");

      script.text = mboxScript.replace(/<\/?script>/g, "");
      window.document.body.appendChild(script);
    });
  }, [mboxes]);

  return null;
};
